import { useData } from '../../contexts/DataContext'
import { useFilters } from '../../contexts/FilterContext'
import FilterGroup from './FilterGroup'

function FilterPanel() {
  const { attributes } = useData()
  const {
    activeCategory,
    filterCount,
    searchTerm,
    setSearchTerm,
    clearFilters,
    hasActiveFilters,
  } = useFilters()

  const currentAttributes = attributes[activeCategory]

  if (!currentAttributes?.groups) {
    return (
      <div className="filter-panel p-6 animate-fade-in">
        <h3 className="font-semibold text-surface-900 mb-3">Filters</h3>
        <div className="flex items-center justify-center py-8">
          <div className="loading-shimmer h-4 w-32 rounded"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="filter-panel p-4 animate-fade-in">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-surface-900 text-lg">
          🔍 Filters
          {filterCount > 0 && (
            <span className="ml-3 px-3 py-1 bg-gradient-to-r from-primary-500 to-primary-600 text-white text-xs rounded-full font-semibold shadow-sm">
              {filterCount}
            </span>
          )}
        </h3>

        {hasActiveFilters() && (
          <button
            onClick={clearFilters}
            className="text-xs text-primary-600 hover:text-primary-700 font-medium transition-colors hover:underline"
          >
            Clear All
          </button>
        )}
      </div>

      {/* Search Input */}
      <div className="mb-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              className="h-4 w-4 text-surface-400"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Search by name..."
            className="w-full pl-10 pr-10 py-2 text-sm border border-surface-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm('')}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-surface-400 hover:text-surface-600 transition-colors"
              aria-label="Clear search"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          )}
        </div>
        {searchTerm && (
          <div className="mt-2 text-xs text-surface-600 flex items-center">
            <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2"></span>
            Searching for: &quot;{searchTerm}&quot;
          </div>
        )}
      </div>

      <div className="space-y-4">
        {currentAttributes.groups.map(group => (
          <FilterGroup key={group.id} group={group} />
        ))}
      </div>

      {/* Filter Summary */}
      {hasActiveFilters() && (
        <div className="mt-4 pt-4 border-t border-surface-200 bg-gradient-to-r from-primary-50/50 to-blue-50/50 rounded-lg p-3">
          <h5 className="text-xs font-semibold text-surface-700 mb-2 flex items-center">
            <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
            Active Filters:
          </h5>
          <div className="text-xs text-surface-600 font-medium">
            {filterCount} filter{filterCount !== 1 ? 's' : ''} applied
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterPanel
